import { type MFAMethod, MfaRequiredError } from 'src/api/APIClient';

export interface PendingMFAChallenge {
    token: string;
    methods: MFAMethod[];
    username: string;
}

export const getInitialMfaMethod = (methods: MFAMethod[]): MFAMethod => {
    if (methods.includes('sms')) {
        return 'sms';
    }
    return methods.includes('totp') ? 'totp' : (methods[0] ?? 'totp');
};

export const toPendingMfaChallenge = (
    error: unknown,
    username: string,
): PendingMFAChallenge | null => {
    if (!(error instanceof MfaRequiredError)) {
        return null;
    }

    return {
        token: error.token,
        methods: error.methods,
        username,
    };
};

export const buildMfaChallengeVerifyRequest = ({
    challenge,
    code,
    method,
}: {
    challenge: PendingMFAChallenge;
    code: string;
    method: MFAMethod;
}) => ({
    mfa_token: challenge.token,
    code: code.trim(),
    method,
});
